import script from "./Subpage1.vue?vue&type=script&setup=true&lang=js"
export * from "./Subpage1.vue?vue&type=script&setup=true&lang=js"

import "./Subpage1.vue?vue&type=style&index=0&id=3de3f8f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3de3f8f7"]])

export default __exports__